import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    Aangifte,
    AangifteRapport,
    BokkzAlgDataService,
    BokkzIbDataService,
    IncomeTaxEntity, Onderneming, Ondernemingsvorm,
    OpbouwInkomenBox1,
    OpbouwWUO,
    SpecificatieJaarrekening,
    SpecificatieWUO
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BehaviorSubject, Subscription} from 'rxjs';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup,} from '@angular/forms';
import {Router} from '@angular/router';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box1-winst-uit-onderneming',
  templateUrl: './box1-winst-uit-onderneming.component.html',
  styleUrls: ['./box1-winst-uit-onderneming.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    DecimalPipe,
    CommonModule
  ]
})
export class Box1WinstUitOndernemingComponent implements OnInit, OnDestroy {
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    private sstRelatieId = {} as string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;
    private partnerSubscription: Subscription | undefined;
    private rapportSubscription: Subscription | undefined;
    private heeftSamenwerkingsverbandSubscription: Subscription | undefined;


    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;
    public showSpinner = true;

    specWUO = {} as AangifteRapport;
    specBelWinstFormGroup = this.fb.group<AangifteRapport>({});
    specBelWinst = {} as AangifteRapport;
    public specJaarrekeningFg = {} as FormGroup
    specJaarr = {} as AangifteRapport[];
    public specWUOFormGroup = {} as FormGroup;
    public ondernemingFG = {} as FormGroup;
    public winstResRekFg = {} as FormGroup;

    public heeftSamenwerkingsverband = {} as boolean;

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder,
    ) {
        this.specWUOFormGroup = this.fb.group<AangifteRapport>({
            specificatieWUO: this.fb.group<SpecificatieWUO>({
                opbouw: this.fb.group<OpbouwWUO>({
                    winstAlleOndernemingen: null as unknown as number,
                    vrijgesteldeWinst: null as unknown as number,
                    winstVoorOndernemersaftrek: null as unknown as number,
                    zelfstandigenaftrek: (null as unknown as number) | 0,
                    startersaftrek: null as unknown as number,
                    zelfstandigenaftrekVoorAOWer: null as unknown as number,
                    senoaftrek: null as unknown as number,
                    meewerkaftrek: null as unknown as number,
                    startersaftrekAO: null as unknown as number,
                    stakingsaftrek: null as unknown as number,
                    restant: null as unknown as number,
                    mkbWinstvrijstelling: null as unknown as number,
                    nietgerealiseerdezelstandigenaftrek: null as unknown as number,
                    totaalBenutteStakingsaftrek: null as unknown as number,
                    dotatieFOR: null as unknown as number,
                    vrijvalFOR: null as unknown as number,
                    eindstandFOR: null as unknown as number,
                    dotatieHIR: null as unknown as number,
                    vrijvalHIR: null as unknown as number,
                    eindstandHIR: null as unknown as number,
                    dotatieKER: null as unknown as number,
                    vrijvalKER: null as unknown as number,
                    eindstandKER: null as unknown as number,
                    mutatieReserves: null as unknown as number,
                    totaleBeginvermogen: null as unknown as number,
                    totaleEindvermogen: null as unknown as number,
                    totaleStortingen: null as unknown as number,
                    totaleOnttrekkingen: null as unknown as number,
                    totaleNietAftrekbareKosten: null as unknown as number,
                    fiscaleWinst: null as unknown as number,
                    maximaleDotatieFor: null as unknown as number,
                    fiscaleWinstMinusOA: null as unknown as number,
                    ondernemersaftrek: null as unknown as number,
                    mkbWinstvrijstellingBijVerlies: null as unknown as number
                } as OpbouwWUO),
            } as SpecificatieWUO),
        } as AangifteRapport);
        this.specBelWinstFormGroup = this.fb.group<AangifteRapport>({
            specificatieInkomenBox1: this.fb.group<OpbouwInkomenBox1>({
                opbouw: this.fb.group<OpbouwInkomenBox1>({
                    winstUitOnderneming: (null as unknown as number) | 0,
                    winstUitOndernemingNegatief: (null as unknown as number) | 0,
                } as OpbouwInkomenBox1),
            } as OpbouwInkomenBox1),
        } as AangifteRapport);
        this.specJaarrekeningFg = this.fb.group({
            specificatieJaarrekening: this.fb.array<SpecificatieJaarrekening>([
                    this.fb.group({
                        opbouw: this.fb.group({
                            winstVolgensResultatenRekening: null as unknown as number,
                            aandeelInWinstVolgensResultatenRekening: null as unknown as number,
                            benutteKIA: null as unknown as number,
                            benutteMIA: null as unknown as number,
                            benutteEIA: null as unknown as number,
                            totaleDIB: null as unknown as number
                        })
                    })
                ]
            )
        });
        this.winstResRekFg = this.fb.group({
            winstResRek: null as unknown as number,
            investeringsaftrek: null as unknown as number
        });
    }

    get specificatieJaarrekening(): FormArray {
        return this.specJaarrekeningFg.get('specificatieJaarrekening') as FormArray;
    }

    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });

        this.dataService.heeftSamenwerkingsverbandWuo.subscribe((heeftSamenwerkingsverband) => {
            this.heeftSamenwerkingsverband = heeftSamenwerkingsverband;
        });

        // ✅ Separate partner subscription
        this.partnerSubscription = this.partner.subscribe((partner) => {
            this.partnerBoolean = partner;
            if (this.incomeTaxEntity.aangifte) { // ✅ Check of data er is
                this.updateRapportData();
                this.updateHeeftSamenwerkingsverband();
            }
        });

        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.winstResRekFg.reset();
                this.specWUOFormGroup.reset();
                this.specBelWinstFormGroup.reset();
                this.specJaarrekeningFg.reset();
                this.aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.partnerAangifte = this.aangifte.partnerAangifte ? this.aangifte.partnerAangifte : ({} as Aangifte);

                // ✅ Roep updateRapportData ook hier aan
                this.updateRapportData();
                this.updateHeeftSamenwerkingsverband(); // ✅ Ook deze aanroepen

                this.disableFormGroup(this.specWUOFormGroup);
                this.disableFormGroup(this.specBelWinstFormGroup);
            }
        });

        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.sstRelatieId = client.sstRelationId!;
        });
    }

    // ✅ Nieuwe methode om rapport data te updaten
    private updateRapportData(): void {
        if (!this.incomeTaxEntity.aangifte) {
            return;
        }

        // Unsubscribe van vorige rapport subscription
        if (this.rapportSubscription) {
            this.rapportSubscription.unsubscribe();
        }

        const rapportObservable = this.partnerBoolean
            ? this.dataService.partnerAangifteRapport
            : this.dataService.aangifteRapport;

        this.rapportSubscription = rapportObservable.subscribe((rapport) => {
            if (!rapport) return;

            this.winstResRekFg.reset();
            this.specWUOFormGroup.reset();
            this.specJaarrekeningFg.reset();
            this.specBelWinstFormGroup.reset();

            // Update specificatie jaarrekening
            this.specJaarr = rapport.specificatieJaarrekening || [];
            const array = this.specJaarrekeningFg.get('specificatieJaarrekening') as FormArray;
            array.patchValue(this.specJaarr);

            // Update WUO
            this.specWUO = rapport;
            const opbouwWUO = this.specWUO?.specificatieWUO?.opbouw;
            if (opbouwWUO) {
                // Mutatie reserves aanpassing
                if (opbouwWUO.mutatieReserves !== 0) {
                    let mutatieReserves = 0;
                    // ✅ Voor partner: *1, voor belastingplichtige: *-1
                    mutatieReserves = this.partnerBoolean
                        ? opbouwWUO.mutatieReserves! * 1
                        : opbouwWUO.mutatieReserves! * -1;
                    opbouwWUO['mutatieReserves'] = mutatieReserves;
                }

                const winstAlleOndernemingen = opbouwWUO?.winstAlleOndernemingen || 0;
                const totaleNietAftrekbareKosten = opbouwWUO.totaleNietAftrekbareKosten || 0;
                const vrijgesteldeWinst = opbouwWUO.vrijgesteldeWinst || 0;
                const winstVoorOndernemersaftrek = opbouwWUO.winstVoorOndernemersaftrek || 0;
                const zelfstandigenaftrek = opbouwWUO.zelfstandigenaftrek || 0;
                const startersaftrek = opbouwWUO.startersaftrek || 0;
                const startersaftrekAO = opbouwWUO.startersaftrekAO || 0;
                const meewerkaftrek = opbouwWUO.meewerkaftrek || 0;
                const stakingsaftrek = opbouwWUO.stakingsaftrek || 0;
                const senoaftrek = opbouwWUO.senoaftrek || 0;
                const ondernemersaftrek = zelfstandigenaftrek + startersaftrek + startersaftrekAO + meewerkaftrek + stakingsaftrek + senoaftrek;

                this.specWUOFormGroup.patchValue({
                    specificatieWUO: {
                        opbouw: {
                            ondernemersaftrek: ondernemersaftrek,
                        },
                    },
                });

                const restant = opbouwWUO.restant || 0;
                const fiscaleWinstMinusOA = winstVoorOndernemersaftrek - ondernemersaftrek - restant;
                opbouwWUO['winstAlleOndernemingen'] = winstAlleOndernemingen;
                opbouwWUO['totaleNietAftrekbareKosten'] = totaleNietAftrekbareKosten;
                opbouwWUO['vrijgesteldeWinst'] = vrijgesteldeWinst;
                opbouwWUO['fiscaleWinstMinusOA'] = fiscaleWinstMinusOA;

                if (opbouwWUO.mkbWinstvrijstelling != null && opbouwWUO.mkbWinstvrijstelling.valueOf() < 0) {
                    opbouwWUO.mkbWinstvrijstelling = Math.abs(opbouwWUO.mkbWinstvrijstelling);
                }
            }

            // Update belastbare winst
            this.specBelWinst = rapport;
            const opbouwBelWinst = this.specBelWinst?.specificatieInkomenBox1?.opbouw;
            if (opbouwBelWinst) {
                const belastbareWinst = opbouwBelWinst.winstUitOnderneming || 0;
                opbouwBelWinst['belastbareWinst'] = belastbareWinst;
            }

            this.specWUOFormGroup.patchValue(this.specWUO);
            this.specBelWinstFormGroup.patchValue(this.specBelWinst);
        });
    }

    private updateHeeftSamenwerkingsverband(): void {
        const ondernemingen = this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen
            : this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen;

        if (ondernemingen && ondernemingen.length > 0 && ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK) {
            this.heeftSamenwerkingsverband = ondernemingen[0].invullenOpNiveauSamenwerkingsverband != undefined && ondernemingen[0].invullenOpNiveauSamenwerkingsverband ;
        } else {
            this.heeftSamenwerkingsverband = false;
        }
    }

    ngOnDestroy(): void {
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
        if (this.partnerSubscription) {
            this.partnerSubscription.unsubscribe();
        }
        if (this.rapportSubscription) {
            this.rapportSubscription.unsubscribe();
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    private getRelevantAangifte(): Aangifte | undefined {
        return this.partnerBoolean
            ? this.aangifte?.partnerAangifte
            : this.aangifte;
    }

    private getOndernemingen(): Onderneming[] | undefined {
        const aangifte = this.getRelevantAangifte();
        return aangifte?.box1?.winstUitOnderneming?.ondernemingen;
    }

    public heeftOndernemingen(): boolean {
        const ondernemingen = this.getOndernemingen();
        return !!ondernemingen && ondernemingen.length > 0;
    }


    private patchPartnerFormGroups(partnerRapport: any) {
        // Assuming partnerRapport has a similar structure to incomeTaxEntity or aangifte
        const opbouwPartnerWUO = partnerRapport?.specificatieWUO?.opbouw;
        const opbouwPartnerBelWinst = partnerRapport?.specificatieInkomenBox1?.opbouw;

        // Patch form group for WUO
        if (opbouwPartnerWUO) {
            const ondernemersaftrekPartner = opbouwPartnerWUO.zelfstandigenaftrek || 0;
            this.specWUOFormGroup.patchValue({
                specificatieWUO: {
                    opbouw: {
                        ondernemersaftrek: ondernemersaftrekPartner,
                    },
                },
            });
        }

        // Patch form group for BelWinst
        if (opbouwPartnerBelWinst) {
            const belastbareWinstPartner = opbouwPartnerBelWinst.winstUitOnderneming || 0;
            this.specBelWinstFormGroup.patchValue({
                specificatieInkomenBox1: {
                    opbouw: {
                        belastbareWinst: belastbareWinstPartner,
                    },
                },
            });
        }
    }

}
